<template>
  <div>
    <Head title="International Purchase Order" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/list/international/purchase-orders">
        International Purchase Orders
      </Link>
      <span class="text-orange-400 font-medium">/</span>Suppliers
    </h1>
    <div class="flex items-center justify-between mb-6 mt-6">
      <search-filter v-model="search.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Purchase Orders:</label>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Supplier Name</th>
          <th class="pb-3 pt-3 px-3">Address</th>
          <th class="pb-3 pt-3 px-3">Country/Region</th>
          <th class="pb-3 pt-3 px-3">Shipment Time (Days)</th>
          <th class="pb-3 pt-3 px-3" colspan="3"></th>
        </tr>
        <tr v-for="supplier in suppliers.data" :key="supplier.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/international/suppliers/${supplier.id}/purchaseOrders`" tabindex="-1">
              {{ supplier.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/international/suppliers/${supplier.id}/purchaseOrders`" tabindex="-1">
              {{ supplier.address }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/international/suppliers/${supplier.id}/purchaseOrders`" tabindex="-1">
              {{ supplier.country }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/international/suppliers/${supplier.id}/purchaseOrders`" tabindex="-1">
              {{ supplier.shipment_time }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3" :href="`/international/suppliers/${supplier.id}/purchaseOrders`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="suppliers.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="suppliers.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    Icon,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    suppliers: Array,
  },
  data() {
    return {
      search: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/international/purchaseOrders', pickBy(this.search), {
          preserveState: true,
          preserveScroll: true,
          replace: true
        })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
  },
}
</script>
